// 封装全局方法，将文本域更改为富文本编辑器格式
const setEditorText = (text) => {
    let textMsg = '';
    if (text) {
        textMsg = text.replace(/\n/g, ',')
        textMsg = textMsg.split(',').map(item => item ? `<p>${item}</p>` : '')
        textMsg = textMsg.join('')
    }
    return textMsg
}

export default setEditorText